"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _FlatButton = _interopRequireDefault(require("material-ui/FlatButton"));
var _IconButton = _interopRequireDefault(require("material-ui/IconButton"));
var _Popover = _interopRequireDefault(require("material-ui/Popover/Popover"));
var _Menu = _interopRequireDefault(require("material-ui/Menu"));
var _moreHoriz = _interopRequireDefault(require("material-ui/svg-icons/navigation/more-horiz"));
require("./PopupMenu.scss");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
/**
 * PopupMenu
 * @description this component extends the MUI-popup
 */
var PopupMenu = /*#__PURE__*/function (_Component) {
  _inherits(PopupMenu, _Component);
  var _super = _createSuper(PopupMenu);
  function PopupMenu(props) {
    var _this;
    _classCallCheck(this, PopupMenu);
    _this = _super.call(this, props);
    _this.state = {
      open: false,
      value: _this.props.value
    };
    _this.handleRequestOpen = _this.handleRequestOpen.bind(_assertThisInitialized(_this));
    _this.handleRequestClose = _this.handleRequestClose.bind(_assertThisInitialized(_this));
    _this.handleMenuChange = _this.handleMenuChange.bind(_assertThisInitialized(_this));
    return _this;
  }
  _createClass(PopupMenu, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      this.setState({
        value: nextProps.value
      });
    }
  }, {
    key: "handleRequestOpen",
    value: function handleRequestOpen(event) {
      event.stopPropagation();
      event.preventDefault();
      this.setState({
        open: !this.state.open,
        anchorEl: event.currentTarget
      });
    }
  }, {
    key: "handleRequestClose",
    value: function handleRequestClose() {
      this.setState({
        open: false,
        value: this.state.value
      });
    }
  }, {
    key: "handleMenuChange",
    value: function handleMenuChange(event, value) {
      event.preventDefault();
      this.setState({
        open: false,
        value: value.replace("-", " ")
      });
      if (typeof this.props.action !== "undefined") {
        this.props.action(value);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var useIconButton = this.props.useIconButton;
      var labelStyle = {
        color: this.props.buttonColorLight,
        textTransform: "capitalize"
      };
      if (this.props.mode === "dark") {
        labelStyle.color = this.props.buttonColorDark;
      }
      var iconButtonStyle = {
        width: 40,
        height: 40,
        padding: 0
      };
      var iconStyle = {
        width: 24,
        height: 24,
        color: "white"
      };
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: "popup-menu ".concat(this.props.className)
      }, useIconButton ? /*#__PURE__*/_react["default"].createElement(_IconButton["default"], {
        className: "icon more",
        style: iconButtonStyle,
        disableTouchRipple: true,
        tooltipPosition: "bottom-center",
        onClick: this.handleRequestOpen
      }, /*#__PURE__*/_react["default"].createElement(_moreHoriz["default"], {
        color: "white",
        style: iconStyle
      })) : /*#__PURE__*/_react["default"].createElement(_FlatButton["default"], {
        labelStyle: labelStyle,
        onTouchTap: this.handleRequestOpen,
        label: this.state.value,
        style: {
          minWidth: 50
        }
      }), /*#__PURE__*/_react["default"].createElement(_Popover["default"], {
        open: this.state.open,
        anchorOrigin: {
          vertical: "top",
          horizontal: "right"
        },
        targetOrigin: {
          vertical: "top",
          horizontal: "right"
        },
        anchorEl: this.state.anchorEl,
        onRequestClose: this.handleRequestClose
      }, /*#__PURE__*/_react["default"].createElement(_Menu["default"], {
        onChange: this.handleMenuChange
      }, this.props.children)));
    }
  }]);
  return PopupMenu;
}(_react.Component);
PopupMenu.defaultProps = {
  mode: "light",
  buttonColorLight: "#d7d7d7",
  buttonColorDark: "rgba(0, 0, 0, 0.54)"
};
PopupMenu.propTypes = {
  buttonColorLight: _propTypes["default"].string,
  buttonColorDark: _propTypes["default"].string,
  mode: _propTypes["default"].string
};
var _default = PopupMenu;
exports["default"] = _default;